import { defineComponent as _defineComponent } from 'vue'
import IconButton from './base/IconButton.vue';
import SwitchThemeIcon from './icons/SwitchThemeIcon.vue';
import { IconButtonLayout } from '../../constants/room';
import { watch } from 'vue';
import { useBasicStore } from '../../stores/basic';
import { storeToRefs } from 'pinia';
import { useI18n } from '../../locales';
interface Props {
  visible?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SwitchTheme',
  props: {
    visible: { type: Boolean, default: true }
  },
  setup(__props: any) {

const basicStore = useBasicStore();
const { defaultTheme } = storeToRefs(basicStore);
const { t } = useI18n();



function handleSwitchTheme() {
  if (defaultTheme.value === 'white') {
    basicStore.setDefaultTheme('black');
  } else if (defaultTheme.value === 'black') {
    basicStore.setDefaultTheme('white');
  }
}

function doSwitchTheme(theme: string) {
  switch (theme) {
    case 'black':
      document.body.classList.remove('tui-theme-white');
      document.body.classList.add('tui-theme-black');
      localStorage.setItem('tuiRoom-currentTheme', 'black');
      break;
    case 'white':
      document.body.classList.remove('tui-theme-black');
      document.body.classList.add('tui-theme-white');
      localStorage.setItem('tuiRoom-currentTheme', 'white');
      break;
  };
}

const storageCurrentTheme = localStorage.getItem('tuiRoom-currentTheme');
if (storageCurrentTheme) {
  basicStore.setDefaultTheme(storageCurrentTheme);
}

watch(defaultTheme, (val: string) => {
  doSwitchTheme(val);
}, { immediate: true });


return { __sfc: true,basicStore, defaultTheme, t, handleSwitchTheme, doSwitchTheme, storageCurrentTheme, IconButton, SwitchThemeIcon, IconButtonLayout }
}

})